import React, {Fragment, useEffect, useState} from 'react';
import Header from "../Header";
import Footer from "../Footer";
import Loading from "../Loading";
import HTTPClient from "../../HTTPClient";
import {useHistory} from "react-router-dom";
import * as axios from "axios";
import Typography from "@material-ui/core/Typography";
import {getMessage} from "../../util";
import {makeStyles} from "@material-ui/core/styles";
import TextField from '@mui/material/TextField';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {StaticTimePicker} from '@mui/x-date-pickers/StaticTimePicker';
import {TimePicker} from "@mui/x-date-pickers";
import {Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Stack} from "@mui/material";

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'left',
    },
    number: {
        fontFamily: "Montserrat",
        "font-size": "1.3rem"
    },
    expanded: {
        width: '100%',
        backgroundColor: 'deepskyblue',
        color: 'antiquewhite',
        fontSize: 'large'
    }
}));

const loadMeeting = async (meeting_id, history) => {
    const meeting = await HTTPClient({
        method: "get",
        url:
            process.env.REACT_APP_API_URL +
            "/meetings/" + meeting_id
    });

    // check if open question
    const open_questions = meeting.data.questions.filter(q => {
        return (!q.url && q.state === 'open')
    });

    if (open_questions.length > 0) {
        history.push('/meeting/' + meeting.data.slug + '/questions');
    }
    return (meeting.data);
}

const Horas = (props) => {

    const classes = useStyles();

    const meeting_id = props.match.params.meeting_id;

    const [loading, setLoading] = useState(false);
    const [help, setHelp] = useState(false);
    const [meeting, setMeeting] = useState(null);
    const [representative, setRepresentative] = useState(null);
    const [hash, setHash] = useState("none");
    const [messages, setMessages] = useState(null);
    const [value, setValue] = useState(new Date('2020-01-01 12:00'));

    const servicios = ['Cambio Domicilio Electoral', 'Clave Única', 'Certificado de Supervivencia', 'Orientación sobre el retiro del 10%', "Productos Banco Estado"]

    const [servicio, setServicio] = useState(servicios[0]);
    const [horasTomadas, setHorasTomadas] = useState([]);

    let history = useHistory();

    const reservar = (servicio,hora,minuto) => {
        setHorasTomadas([...horasTomadas, {servicio: servicio, hora: hora, minuto: minuto}]);
    }

    const resetLanguage = (event) => {
        localStorage.setItem('eholder-lang-' + meeting_id, event.target.value);
        messages.lang = event.target.value;
        setMessages({...messages});
    }


    // effect to reload meeting when changed hash
    useEffect(() => {
        (async () => {
            try {
                const meeting = await loadMeeting(meeting_id, history);
                setMeeting(meeting);


            } catch (error) {
                console.log("Main.js useEffect-hash loadMeeting error: ", error);
                switch (error.response.status) {
                    case 401:
                        window.location = '/login/' + meeting_id;
                        break;
                    case 403:
                        window.location = '/meeting/' + meeting_id + '/pending';
                        break;
                    default:
                        setLoading(false);
                        break;
                }
            }
        })()
    }, [hash]);

    // effect only once
    useEffect(() => {
        setLoading(true);
        (async () => {
            try {
                // load the meeting the first time
                const meeting = await loadMeeting(meeting_id, history);

                // load messages
                if (meeting.messages) {
                    const load_messages = await axios({
                        method: "get",
                        url: meeting.messages
                    });
                    const messages = load_messages.data;
                    const nav_lang = navigator.language.split('-')[0];

                    messages.lang = messages.languages.length > 1 ? (localStorage.getItem('eholder-lang-' + meeting_id) || nav_lang) : nav_lang;
                    setMessages(messages);
                }

                //load user
                const me = await HTTPClient({
                    method: "get",
                    url:
                        process.env.REACT_APP_API_URL +
                        "/meetings/" + meeting_id + "/me"
                });


                setMeeting(meeting);
                setRepresentative(me.data);
                setLoading(false);

                const intervalId = setInterval(() => {
                    (async () => {
                        try {
                            const got_hash = await HTTPClient({
                                method: "get",
                                url:
                                    process.env.REACT_APP_API_URL +
                                    "/meetings/" + meeting_id + "/hash"
                            });
                            setHash(got_hash.data);
                        } catch (error) {
                            console.log("Main.js useEffect-meetingId hash error: ", error);
                            switch (error.response.status) {
                                case 401:
                                    window.location = '/login/' + meeting_id;
                                    break;
                                case 403:
                                    window.location = '/meeting/' + meeting_id + '/pending';
                                    break;

                                default:
                                    setLoading(false);
                                    break;
                            }
                        }
                    })();
                }, 3000);
                return (() => {
                    clearInterval(intervalId);
                });
            } catch (error) {
                console.log("Main.js useEffect-meetingId loadMeeting error: ", error);
                switch (error.response.status) {
                    case 401:
                        window.location = '/login/' + meeting_id;
                        break;
                    case 403:
                        window.location = '/meeting/' + meeting_id + '/pending';
                        break;
                    default:
                        setLoading(false);
                        break;
                }
            }
        })();
    }, [meeting_id]);


    const sendMessage = async (reason, help) => {

        const connect = async (data) => HTTPClient({
            method: "post",
            data: data,
            url:
                process.env.REACT_APP_API_URL +
                "/login/send_phone"
        })
            .then(response => {

            });


        if (process.env.REACT_APP_RECAPTCHA_ENABLED !== "false") {
            window.grecaptcha.enterprise.ready(async () => {
                window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE, {action: 'id_password'}).then(async token => {
                    const data = {
                        email: representative.identity,
                        gRecaptchaResponse: token,
                        jwt: "eyJhbGciOiJFUzI1NiIsImp3ayI6eyJrdHkiOiJFQyIsImNydiI6IlAtMjU2IiwieCI6ImJaSDdWWjVJTF95eVU0SnNELTQ1dC1WdDBNVGtvS0JsUTdfVld1bWFiNVEiLCJ5IjoiRjhfem8wQzRTRHVQUU02dmN4N1ZFUVZvYUdaNkdzVzVXWm5xRnZIbWR2TSJ9fQ.eyJzdWIiOiJjbC5ldm90aW5nLmF1dGhlbnRpY2F0ZS5ydW4iLCJyZWFzb24iOiJ3cm9uZyBwYXNzd29yZCIsImlkZW50aXR5IjoiMTA1ODIxNTgtMSIsIm1lZXRpbmdfaWQiOiJYalBhNDBOWiIsImlzcyI6ImNsLmV2b3RpbmcuYWNjaW9uaXN0YXMiLCJzdGF0ZSI6Indyb25nIiwiaWF0IjoxNjUzMDk0OTQ1fQ.D4jNyFNTDYzq4xgKugnKRgsI9LDH3coKu_uyTFYFmMo0kaDWFN2Hda-2kCxv5J38h4g3RUbqqQ9tSatuqqqPxg",
                        name: representative.name,
                        phone: "234234234",
                        reason: reason
                    }
                    await connect(data);
                })
            })
        } else {
            const data = {
                reason: 'piede ayuda',
                representative: representative
            }
            await connect(data);
        }

        setHelp(help);
    }


    return (
        <Fragment>
            {loading ? (
                <Loading/>
            ) : (

                (meeting && representative) ? (
                    <Fragment>

                        <Header messages={messages} user={representative} logo={meeting.logo} meeting={meeting}
                                resetLanguage={resetLanguage}/>
                        <hr/>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <h3>Reservar una hora</h3>

                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Box sx={{minWidth: 120}}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Servicio</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="servicio"
                                                value={servicio}
                                                onChange={(e) => setServicio(e.target.value)}
                                            >
                                                {servicios.map(servicio => (
                                                    <MenuItem key={servicio} value={servicio}>{servicio}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box> </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <TimePicker
                                            renderInput={(params) => <TextField {...params} />}
                                            label="Seleccione una hora disponible"
                                            value={value}
                                            onChange={(newValue) => {
                                                setValue(newValue);
                                            }}
                                            shouldDisableTime={(timeValue, clockType) => {
                                                if (clockType === 'hours'){
                                                    return(false);

                                                }

                                                if (clockType === 'minutes' && timeValue % 15) {
                                                    return true;
                                                }

                                                return false;
                                            }}
                                        />


                                    </LocalizationProvider> </Grid>
                                <Grid item xs={12} sm={6} md={3}
                                >
                                    <Button variant="contained" onClick={() => reservar(servicio,value.getHours(),value.getMinutes())} >Reservar</Button>
                                </Grid>
                            </Grid>

                        <h3>Horas Reservadas:</h3>
                        <ul>
                            {horasTomadas.map(h => (
                                <li key={h.servicio+h.hora+h.minuto}>{h.servicio} - {h.hora}:{h.minuto}</li>
                            ))}
                        </ul>




                        <Footer messages={messages} meeting={meeting}/>
                    </Fragment>
                ) : (
                    <Typography variant="h5" component="h2">
                        {getMessage('default', 'meeting_not_found', null)}
                    </Typography>
                )
            )
            }
        </Fragment>
    );
}

export default Horas;
